// extracted by mini-css-extract-plugin
module.exports = {"count-down":"count-down___g47i1","count-down-item":"count-down-item___25V-c","flag-wrapper":"flag-wrapper___2UwEg"};